<template>
  <div>
    <p>
      The inter-plane phasing coefficient f, defines the angular difference
      between two spacecrafts of two consecutive planes. This difference is
      represented on the figure below by the angle
      <katex-element expression="\phi_\text{inter}" />.
      <br />
      <br />
      <v-img
        contain
        :src="require('../../../assets/images/tooltip-inter-plane-phasing.png')"
        aspect-ratio="1.8"
      />
      <br />
      The value of the angular difference is
      <katex-element expression="2\pi f \text{/} t" /> where
      <katex-element expression="t" /> is the total number of spacecraft in the
      constellation. Since <katex-element expression="f" /> represents the
      number of subdivisions between the first vehicle in adjacent planes, its
      value must be lower than the total number of planes
      <katex-element expression="p" />.
      <br />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryInterplanePhasingCoefficient'
}
</script>
